import React, { Fragment, useEffect, useState } from "react";
import "./index.css";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, ButtonGroup } from "reactstrap";
import Stepper from "react-stepper-horizontal";
import Tasks from "./Tasks";
import TrackedApplicationModal from "./TrackedApplicationModel";
import { getTrackeApplication, trackeApplication } from "../../api/Activity";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader/Loader";
import { failed, success } from "../../utils/Tostify";
import { decryptPatientData } from "../../utils/common";
import moment from "moment";
import { calculateAge } from "../../utils/DateSupport";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
import { createApplicationActivity, getPendingTasks, updateTask } from "../../api/Applications";
import AddApplicationDocumentModal from "../applications/Documents/AddDocument";
import PdfViewer from "../../components/PdfViewer/PdfViewer";
import { Link, useLocation } from "react-router-dom";
import { decryptData } from "../../utils/helper";
import { signIn } from "../../api/auth";
import { handleFileUpload } from "../../utils/ImageToBase64";
import { uploadOrUpdateDocument } from "../../api/patient";
import { ActivityDetails } from "../../utils/constants";

function Activity({ direction, ...args }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [openTaskForm, setOpenTaskForm] = useState(false);
  const [loginUser, setLoginUser] = useState(null);
  const [trackedApplication, setTrackedApplication] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [pendingTasks, setPendingTasks] = useState([]);
  const [pdfUrl, setPdfUrl] = useState("");
  const location = useLocation();
  const [actionStatus, setActionStatus] = useState(location?.state?.activeTab ? location?.state?.activeTab :"pending");
  const [showPdfViewModal, setShowPdfViewModal] = useState(false);
  const [showDocModal, setShowAddDocModal] = useState(false);
  const [applicationId, setapplicationId] = useState("");
  const [formData, setFormData] = useState({});
  const { getConfirmation } = useConfirmDialog();
  const [filterApplication, setFilterApplication] = useState([]);
  const [filteredPendingTasks, setFilteredPendingTask] = useState([]);
  let user = useSelector((state) => state?.userReducer?.user);
  const clinicId = localStorage.getItem("currentHospitalId");
  const [taskId, setTaskId] = useState("");

  let token = useSelector((state) => state.userReducer.token);
  const dispatch = useDispatch();

  const handleSignIn = async () => {
    try {
      const values = {email : user?.email, password : "loginFromHeader"};
      const res = await signIn({ values, dispatch });
      const responseData = decryptData(res?.data?.encryptedResponse);
      setLoginUser(responseData);
    } catch (error) {
        // console.error("Sign-in failed:", error);
    }
};

  useEffect(() => {
    handleSignIn();
}, []);

  const handleUnFollow = async(appId)=>{
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName: "",
      actionBtnTitle: "Yes",
      message: "Are you sure want to unfollow the application."
    });
    if(confirmed){
      let res;
      try {
        const values = {
          applicationId : appId,
          action : "delete"
        };
        setIsLoading(true);
        res = await trackeApplication({ values, dispatch, token });
        if (res?.status == "SUCCESS") {
          await trackedApplications();
          setShowModal();
          setIsLoading(false);
          success(res?.message);
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  };

  const trackedApplications = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getTrackeApplication({dispatch, token, clinicId});
      if (res?.status === "SUCCESS") {
          await Promise.all(
          res?.data?.map(async (patient) => {
            patient.patientData = patient.patientId;
            patient.patientId = await decryptPatientData(patient?.patientId);
          })
        );
        setTrackedApplication(res.data);
        setIsLoading(false);
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  //sorted task desc
  const PendingTasks = async () => {
    let res;
    try {
        setIsLoading(true);
        res = await getPendingTasks({ dispatch, token, clinicId, userId: user._id });
        if (res?.status === "SUCCESS") {
            setFilterApplication(res.data);
            let allTasks = res.data.flatMap(item => item.tasks);

            await Promise.all(
                allTasks?.map(async (task) => {
                    if (task.patientId) {
                        task.patientData = task.patientId;
                        task.patientId = await decryptPatientData(task?.patientId);
                    }
                    // Find the application that contains the formId
                    const application = res.data.find(app => app?._id === task?.applicationId);
                    if (application && Array.isArray(application.applicationForms)) {
                        const applicationForm = application.applicationForms.find(form => String(form.formId) === String(task.formId));
                        if (applicationForm) {
                            task.signedUrl = applicationForm?.formFile?.signedUrl;
                        }
                    }
                })
            );

            // **Sort tasks AFTER all decryption is done**
            allTasks.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));

            // Update state
            setPendingTasks(allTasks);
            setFilteredPendingTask(allTasks);
        }

    } catch (error) {
        failed(res?.message);
    } finally {
        setIsLoading(false);
    }
  };



  const triggerFileInputDoc = (appId, taskId, index) => {
    setapplicationId(appId); // Trigger file input
    document.getElementById(`fileInputDoc-${appId}-${taskId}-${index}`)?.click();
    setTaskId(taskId);
  };

  useEffect(() => {
    trackedApplications();
    PendingTasks();
   }, []);

  useEffect(()=>{
    if(actionStatus === "completed"){
      setPendingTasks(filteredPendingTasks.filter((item) => item.status === "Completed"));
    }else if(actionStatus === "pending"){
      setPendingTasks(filteredPendingTasks.filter((item) => item.status !== "Completed"));
    }else if (actionStatus === "assigned") {
      setPendingTasks(filteredPendingTasks.filter((item) => item.assignTo?._id === user._id && item.status !=="Completed"));
    }else{
      setPendingTasks(filteredPendingTasks);
    }
  },[actionStatus, filteredPendingTasks]);



  const handleDocUpdate = async(file, docId, taskId,task,applicationId) => {

    let res;
    try {
      let base64pdfForm = "";
          base64pdfForm = await handleFileUpload(file);
          const fileExtension = file?.type?.split("/")[1];
          const docFile = {
              base64String: base64pdfForm,
              extension: fileExtension, // Add the file extension to the object
              name: file?.name
          };
          const payload = {file : docFile};
      setIsLoading(true);
      res = await uploadOrUpdateDocument({ values : payload, dispatch, token, patientId: task.patientId._id, documentId : docId, uploadedBy: user._id, applicationId: applicationId, type: "task"});
      if (res?.status === "SUCCESS") {
        let values = {
          type : "Application",
          event : ActivityDetails?.DocumentUploadDownload?.event,
          applicationId : task.applicationId,
          clinicId: localStorage.getItem("currentHospitalId"),
          organizationId: localStorage.getItem("currentOrgId"),
          patientId :  task.patientId._id,
          details : "Document Uploaded."
        };
        const payload = {tasks : { status : "Completed"}  };
        await updateTask({values:payload, dispatch, token, applicationId: task.applicationId, taskId});
        await createApplicationActivity({ values, dispatch, token });
        await PendingTasks();
        success(res.message);
        setIsLoading(false);
      }else{
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      // console.log(error);
      failed(res?.message);
      setIsLoading(false);
    }
  };

    const handleFileSelect = (event,taskId, docId,task, applicationId) => {
      const file = event.target.files[0];
      if (file) {
        (file);
          handleDocUpdate(file, docId, taskId, task, applicationId);
      }
    };

  return (
    <Fragment>
      {isLoading ? <Loader/> : null}
      {showModal ? <TrackedApplicationModal refech={trackedApplications} handleSignIn={handleSignIn} trackedApplication={trackedApplication} setShowModal={()=> setShowModal(!showModal)}/> : null}
      {showDocModal ? <AddApplicationDocumentModal refetch={getPendingTasks} setShowModal={()=> setShowAddDocModal(!showDocModal)} status={"Completed"} taskId={taskId} applicationId={applicationId}/> : null}
      {showPdfViewModal ? <PdfViewer url={pdfUrl} formData={formData} setShowModal={()=> !setShowPdfViewModal(!showPdfViewModal)} refetch={()=>{}}/> : null}
      <div className="activity-container">
        <div className="d-flex gap-4 justify-content-between flex-wrap main_cards">
          <div className="tracked_app">
            <div className="d-flex justify-content-between align-items-center tracked_block">
              <h2>Tracked Applications</h2>
              <div className="drop_block">
                <Dropdown direction={direction} isOpen={dropdownOpen} toggle={() => setDropdownOpen((prev) => !prev)}>
                  <DropdownToggle caret className="pro_text">
                    {/* <div className="for_details header-add-icon"> */}
                      <i className="fa fa-ellipsis-v" ></i>
                    {/* </div> */}
                  </DropdownToggle>
                  <DropdownMenu {...args} >
                    <DropdownItem onClick={() => setShowModal(true)} className="d-flex gap-2 drop_block_content align-items-center">
                      <div className="add_hosp">
                        Follow Application
                      </div>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
            <div className="tracker_blk">
              {trackedApplication?.length > 0 ? trackedApplication?.map((obj) => {
                const birthDate = obj?.patientId?.birthDate;
                const formattedBirthDate = birthDate ? moment(birthDate).format("DD-MM-YYYY") : "Unknown Date";
                const age = formattedBirthDate ? calculateAge(formattedBirthDate) : "Unknown Age";
                const activeStepIndex =
                  obj?.stages?.some((stage) => stage.status === "NotApproved")
                    ? obj.stages.findIndex((stage) => stage.status === "NotApproved")
                    : obj.stages.every((stage) => stage.status === "Approved")
                      ? obj.stages.length
                      : obj.stages.findIndex((stage) => stage.status === "InProcess") !== -1
                        ? obj.stages.findIndex((stage) => stage.status === "InProcess")
                        : obj.stages.findIndex((stage) => stage.status === "NotStarted") !== -1
                          ? obj.stages.findIndex((stage) => stage.status === "NotStarted")
                          : obj.stages.length - 1;

                const activeStepStatus =
                  obj?.stages.find(step => step.status === "NotApproved")?.status ||
                  obj?.stages.find(step => step.status === "InProcess")?.status ||
                  obj?.stages.find(step => step.status === "NotStarted")?.status;

                const activeColor = activeStepStatus === "NotApproved"
                  ? "#E44545"
                  : activeStepStatus === "InProcess"
                    ? "#ECB800"
                    : activeStepStatus === "NotStarted"
                      ? "#8B8D91"
                      : "#339900";

                const activeTitleColor = activeStepStatus === "NotApproved"
                  ? "#E44545"
                  : activeStepStatus === "InProcess"
                    ? "#ECB800"
                    : activeStepStatus === "NotStarted"
                      ? "#8B8D91"
                      : "#339900";

                const activeBarColor = activeStepStatus === "NotApproved"
                  ? "#E44545"
                  : activeStepStatus === "InProcess"
                    ? "#ECB800"
                    : activeStepStatus === "NotStarted"
                      ? "#8B8D91"
                      : "#339900";
                return (
                  <>
                    <div className="d-flex align-items-center gap-2 all_check">
                      <div className="tracking_block mb-4">
                        <div className="first_track_block">
                          <p>
                            <Link
                              to="/clinic/patient-profile"
                              className="title_name"
                              state={{ patientData: obj?.patientId?._id }}
                            ><span>{obj?.patientId?.name?.text} </span></Link> | {age} | {obj?.patientId?.address?.state} - {obj?.title}
                          </p>
                          <div className="stepper-container">
                            <Stepper
                              activeColor={activeColor}
                              defaultColor="#8B8D91"
                              completeColor="#339900"
                              activeTitleColor={activeTitleColor}
                              completeTitleColor="#339900"
                              activeBarColor={activeBarColor}
                              completeBarColor="#339900"
                              steps={obj?.stages.map((step) => ({
                                title: (
                                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <h6>{step?.name}</h6>
                                    {step?.status === "InProcess" && (
                                      <button
                                        style={{
                                          marginLeft: '10px',
                                          backgroundColor: '#335FFC',
                                          color: '#fff',
                                          border: 'none',
                                          borderRadius: '4px',
                                          padding: '4px 6px',
                                          fontWeight:"600",
                                          cursor: 'pointer'
                                        }}
                                      >
                                        Current Stage
                                      </button>
                                    )}
                                  </div>
                                )
                              }))}
                              activeStep={activeStepIndex}
                            />
                          </div>
                        </div>
                        <div className="describe d-flex align-items-center justify-content-between">
                        <p>Latest Activity : {obj?.activityFeed?.[0]?.details || "No activity yet"}</p>
                        <Link
                          to="/app/application-detail"
                          state={{applicationData : {...obj, patientData : obj?.patientData}}}
                          className="d-flex flex-column gap-1 align-items-center"
                        >
                          <button className="details">
                            <i className="fa fa-external-link"></i> View Details
                          </button>
                        </Link>
                        </div>
                        </div>
                        {
                          loginUser?.trackedApplicationsIds?.includes(obj?._id) &&
                          trackedApplication.some(app => app._id === obj?._id) && (
                            <span
                            className="unfollow_button"
                            style={{ cursor: "pointer" }}
                              onClick={() => handleUnFollow(obj?._id)}
                            >
                              unfollow
                            </span>
                          )
                        }
                      </div>
                    </>
                );
              }) : null}
            </div>
          </div>
        </div>
        {!openTaskForm ? (
          <div className="pending_action">
            <div className="d-flex align-items-center justify-content-between gap-2 pending_action_header flex-wrap">
              <div className="d-flex header_blk align-items-center">
                <h2>Pending Actions</h2>
                <button
                  className="schedule_btn"
                  onClick={() => setOpenTaskForm((prev) => !prev)}
                >
                  {" "}
                  <i className="fa fa-plus"></i> Schedule a Task
                </button>
              </div>
              <ButtonGroup className="flex-wrap button_tabsss">
                <Button className={`left_btn ${actionStatus === "all" ? "active" : ""}`} onClick={()=> setActionStatus("all")}>Total Actions ({filteredPendingTasks?.length})</Button>
                <Button className={`middle_btn ${actionStatus === "pending" ? "active" : ""}`} onClick={()=> setActionStatus("pending")}>All Pending Actions ({filteredPendingTasks?.filter((obj)=> obj?.status !== "Completed")?.length})</Button>
                <Button className={`middle_btn ${actionStatus === "completed" ? "active" : ""}`} onClick={()=> setActionStatus("completed")}>Completed Actions ({filteredPendingTasks?.filter((obj)=> obj?.status == "Completed")?.length  })</Button>
                <Button
                  className={`right_btn ${actionStatus === "assigned" ? "active" : ""}`}
                  onClick={() => setActionStatus("assigned")}
                >
                  My Pending Actions ({filteredPendingTasks?.filter((obj) => obj?.assignTo?._id === user._id && obj.status !== "Completed")?.length})
                </Button>
              </ButtonGroup>
            </div>
            <div className="p-4">
              <div className="action_type">
                {pendingTasks?.length > 0 ? pendingTasks
                  .slice() // Clone the array to avoid mutating the original
                  .sort((a, b) => {
                      const momentA = moment(a.dueDate, "MM-DD-YYYY");
                      const momentB = moment(b.dueDate, "MM-DD-YYYY");
                      const isOverdueA = a?.dueDate && momentA.isBefore(moment()) && a.status !== "Completed";
                      const isOverdueB = b?.dueDate && momentB.isBefore(moment()) && b.status !== "Completed";

                      // Sort overdue tasks first
                      if (isOverdueA && !isOverdueB) return -1;
                      if (!isOverdueA && isOverdueB) return 1;

                      // Then sort pending tasks next
                      if (a.status !== "Completed" && b.status === "Completed") return -1;
                      if (a.status === "Completed" && b.status !== "Completed") return 1;

                      // If both are overdue or both are pending, sort by due date (ascending)
                      if (a.status !== "Completed" && b.status !== "Completed") {
                          return momentA - momentB;
                      }

                      // Finally, sort completed tasks by creation date (descending)
                      return new Date(b.createdAt) - new Date(a.createdAt);
                  })
                  .map((task, index) => (
                    <>
                      <div className={`action_blk ${
                        task?.status === "Completed"
                          ? "status_complete"
                          : task?.dueDate && moment(task.dueDate, "MM-DD-YYYY").isBefore(moment())
                          ? "status_overdue"
                          : "status_pending"
                      }`}>
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-4">
                            <i className={`fa ${task?.status === "Completed" ? "fa-check-circle" : "fa-info-circle"}`}
                              style={{
                                color: task?.status === "Completed"
                                  ? "green"
                                  : task?.dueDate && moment(task.dueDate, "MM-DD-YYYY").isBefore(moment())
                                  ? "red"
                                  : "orange"
                              }}
                            ></i>
                            {task.status === "Completed" ? (
                              <p className="due_block">Completed</p>
                            ) : (
                              <p className="due_block">
                                {task?.dueDate
                                  ? (() => {
                                      const dueDate = moment(task.dueDate, "MM-DD-YYYY");
                                      const diff = dueDate.diff(moment(), "days");

                                      return diff >= 0
                                        ? `Due in ${diff} Days`
                                        : `${Math.abs(diff)} Days Pass Due Date`;
                                    })()
                                  : "Due Date: N/A"}
                              </p>
                            )}
                            <div className="divider-block"></div>
                            <div>
                              <Link to={`/app/application-detail`}
                                state={{ applicationData: filterApplication.find(item => item?._id === task?.applicationId), activeTab: "5" }}
                              >
                                <p className="desc_action_title" style={{ color: "#335FFC" }}>
                                  {task.title}
                                </p>
                              </Link>
                              <p className="desc_action">
                                {task.assignTo
                                  ? `Task Action ${task?.taskAction} created by ${task.editedBy?.firstName + " " + task.editedBy?.lastName} currently assigned to ${task.assignTo?.firstName} ${task.assignTo?.lastName || ''}`
                                  : `Task Action ${task?.taskAction} created by ${task.editedBy?.firstName + " " + task.editedBy?.lastName} Currently Assigned to patient ${task?.patientId?.name?.text}`}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            {task?.taskAction === "Upload Document" && (
                              task?.status === "Completed" ? (
                                <button
                                  className="details"
                                  onClick={() => { setShowPdfViewModal(true); setPdfUrl(task?.signedUrl || task?.documentDetails?.filePath?.signedUrl); setFormData(task); }}
                                >
                                  View
                                </button>
                              ) : (
                                 <>
                            <button
                              className="schedule_btn"
                              onClick={() => triggerFileInputDoc(task?.applicationId, task?._id, index)}
                            >
                              Upload
                            </button>
                            <input
                              type="file"
                              id={`fileInputDoc-${task?.applicationId}-${task?._id}-${index}`}
                              style={{ display: "none" }}
                              onChange={(e) =>
                                handleFileSelect(e, task?._id, task?.documentId, task, task?.applicationId)
                              }
                            />
                          </>
                              )
                            )}
                            {task?.taskAction !== "Upload Document" && (
                              <button className={`${task?.status === "Completed" ? "details" : "schedule_btn"}`}
                                onClick={() => { setShowPdfViewModal(true); setPdfUrl(task?.signedUrl); setFormData(task); }}
                              >
                                {task?.status === "Completed"
                                  ? "View"
                                  : task?.taskAction === "Sign Form"
                                  ? "Sign"
                                  : task?.taskAction === "Verify Form"
                                  ? "Verify"
                                  : task?.taskAction === "Update Form"
                                  ? "Update"
                                  : "View"}
                              </button>
                            )}
                            {/* {task?.taskAction === "Update Form" && task?.status !== "Completed" && (
                              <button className="schedule_btn"
                                onClick={() => handleFinishForm({ "taskId": task?._id, "status": "Pending", "applicationId": task?.applicationId, formId: task?.formId })}
                              >
                                Finish
                              </button>
                            )} */}
                          </div>
                        </div>
                      </div>
                    </>
                  )) : <h4 className="d-flex justify-content-center">No Data</h4>}

              </div>
            </div>
          </div>
        ) : (
          <Tasks setOpenTaskForm={() => setOpenTaskForm(false)} PendingTasks={PendingTasks} />
        )}
      </div>
    </Fragment>
  );
}

export default Activity;
